import React, {useState} from 'react';
import TogglerBody from '../TogglerBody';
import ChooseActionTamplate from '../actionTamplate/ChooseActionTamplate';
import CustomSliderRange from '../sliders/CustomSliderRange';
import CounterTemplate from '../status/statusBlock/CounterTemplate';
import {RxCross1} from 'react-icons/rx';
import TipsTamplate from '../TipsTamplate';
import './flagCustomisation.scss';
import {statusActionsAdvanced} from '../../../constants/common';
import {useAdvanceChanges} from '../../../hooks/useAdvanceChanges';

const FlagCustomisationItemInputs = ({item, data}) => {
  const [isOnPunish, setIsOnPunish] = useState(data ? data[item.trigger] : '');
  const [currentAction, setCurrentAction] = useState(
    data && data?.[item.keyName] ? data?.[item.keyName] : 'Kick',
  );
  const [inputStrictWord, setInputStrictWord] = useState('');
  const [strictWords, setStrictWords] = useState(
    data && data?.[item.strictWords] ? data?.[item.strictWords] : [],
  );
  const [inputWDWords, setInputWDWords] = useState('');
  const [wildcardWords, setWildcardWords] = useState(
    data && data?.[item.wildcardWords] ? data?.[item.wildcardWords] : [],
  );
  const {addAdvanceChangeToStore} = useAdvanceChanges();

  const addNewStrictWord = () => {
    const newWord = {
      name: inputStrictWord,
      color: '',
      img: '',
    };
    setStrictWords((prev) => [...prev, newWord]);
    addAdvanceChangeToStore({key: item.strictWords, value: [...strictWords, newWord]});
    setInputStrictWord('');
  };

  const handleKeyPressStrictWord = (e) => {
    if (inputStrictWord && e.key === 'Enter') {
      addNewStrictWord();
    }
  };

  const deleteStrictWord = (index) => {
    const newWords = strictWords.filter((_, idx) => idx !== index);
    setStrictWords(newWords);
    addAdvanceChangeToStore({key: item.strictWords, value: newWords});
  };

  const addNewWDword = () => {
    const newWord = {
      name: inputWDWords,
      color: '',
      img: '',
    };
    setWildcardWords((prev) => [...prev, newWord]);
    addAdvanceChangeToStore({key: item.wildcardWords, value: [...wildcardWords, newWord]});
    setInputWDWords('');
  };

  const handleKeyPressUser = (e) => {
    if (inputWDWords && e.key === 'Enter') {
      addNewWDword();
    }
  };

  const deleteWDWord = (index) => {
    const newWords = wildcardWords.filter((_, idx) => idx !== index);
    setWildcardWords(newWords);
    addAdvanceChangeToStore({key: item.wildcardWords, value: newWords});
  };

  return (
    <div style={{gap: '15px'}} className="flag_customisation_item_wrap">
      <h4>
        {item.title}
        {item.title === 'Webhook Management' ||
        item.title === 'Mass Spam' ||
        item.title === 'Name Similarity' ||
        item.title === 'AI-Based Text' ||
        item.title === 'Cross-server behaviour' ||
        item.title === 'Cross-Server Monitor' ? (
          <label htmlFor="">PRO</label>
        ) : (
          <></>
        )}
      </h4>
      <p>Status</p>
      <div className="status_block_item_toggler">
        <TogglerBody isOn={isOnPunish} setIsOn={setIsOnPunish} keyName={item.trigger} advance />
        {/* <p>{target}</p> */}
        <p>{item?.targetTogler || 'Monitor kicks, bans and timeouts'}</p>
      </div>
      {item.counter.map((count, idx) => (
        <div>
          <p style={{marginBottom: '10px'}}>{count.title}</p>
          <CounterTemplate valueTitle={count.target} valueTime={count.time} />
        </div>
      ))}
      {/* <p>Ban Frequency</p>
            <CounterTemplate
            valueTitle={'bans'}
            valueTime={'day'}
            />

                        <p>Timeout Frequency</p>
            <CounterTemplate
            valueTitle={'bans'}
            valueTime={'day'}
            /> */}
      {item?.targetSlader && (
        <>
          <p>Flag Sensitivity</p>
          <CustomSliderRange
            currentAction={currentAction}
            setCurrentAction={setCurrentAction}
            item={statusActionsAdvanced}
            color={'yellow'}
          />
        </>
      )}

      {item?.chooseActionTarget && (
        <>
          <p>Punishment</p>
          <ChooseActionTamplate
            currentAction={currentAction}
            setCurrentAction={setCurrentAction}
            actionArr={statusActionsAdvanced}
            keyName={item.keyName}
            advance
          />
        </>
      )}
      <div className="white_list_block_item">
        {/* <div className='white_list_block_item_title_block'>
                    
                    <img src="/img/Question.svg" alt="" />
                </div> */}
        <div className="white_list_block_item_title_block flag_customisation_item_wrap_title">
          <p className="white_list_block_item_title">Strict words</p>
          <TipsTamplate
            title={'Strict words'}
            label={'Safe'}
            text={
              '<p>The username must include a WORD that matches exactly one of the words below. Case insensitive.</p>'
            }
            textSecond={
              '<p>Note: Themis uses a normalisation algorithm before matching. This means that users attempting to bypass it using customisable fonts and Zalgo characters won`t succeed.</p>'
            }
          />
        </div>
        <div className="white_list_block_item_arr_user_wrap">
          {strictWords.map((item, idx) => (
            <div key={idx} className="access_component_user_one white_list_block_user_one">
              {item?.img && <img src={`/img/user/${item?.img}.svg`} alt="" />}
              {/* { item?.color &&
                                    <div className='access_component_user_one_color' style={{background:`#${item?.color}`}}></div>
                                } */}
              <p>{item.name}</p>
              <span
                className="access_component_user_one_delete-icon"
                onClick={() => deleteStrictWord(idx)}>
                <RxCross1 />
              </span>
            </div>
          ))}
          <input
            type="text"
            placeholder="..."
            value={inputStrictWord}
            onChange={(e) => {
              setInputStrictWord(e.target.value);
            }}
            onKeyPress={handleKeyPressStrictWord}
          />
        </div>
      </div>
      <div className="white_list_block_item">
        <div className="white_list_block_item_title_block flag_customisation_item_wrap_title">
          <p className="white_list_block_item_title">Wildcard words</p>
          <TipsTamplate
            title={'Strict words'}
            label={'Safe'}
            text={
              '<p>The username must include a WORD that matches exactly one of the words below. Case insensitive.</p>'
            }
            textSecond={
              '<p>Note: Themis uses a normalisation algorithm before matching. This means that users attempting to bypass it using customisable fonts and Zalgo characters won`t succeed.</p>'
            }
          />
        </div>
        <div className="white_list_block_item_arr_user_wrap">
          {wildcardWords.map((item, idx) => (
            <div key={idx} className="access_component_user_one white_list_block_user_one">
              {item?.img && <img src={`/img/user/${item?.img}.svg`} alt="" />}
              {/* {item?.color && (
                <div
                  className="access_component_user_one_color"
                  style={{background: `#${item?.color}`}}></div>
              )} */}
              <p>{item.name}</p>
              <span
                className="access_component_user_one_delete-icon"
                onClick={() => deleteWDWord(idx)}>
                <RxCross1 />
              </span>
            </div>
          ))}
          <input
            type="text"
            placeholder="..."
            value={inputWDWords}
            onChange={(e) => {
              setInputWDWords(e.target.value);
            }}
            onKeyPress={handleKeyPressUser}
          />
        </div>
      </div>
    </div>
  );
};

export default FlagCustomisationItemInputs;
